import {DtoDetail} from "features/core/shared/dto/dto.detail";
import {ProvisionStatementStatus} from "../../../enum/provision-statement-status.enum";
import type {ProvisionRunDto} from "./provision-run.dto";
import type {ProvisionAgentDto} from "./provision-agent.dto";
import type {DmDocumentDto} from "features/feature-core/dm/model/dto/entity/dm-document.dto";

/**
 * ProvisionAgentStatement — the stored FINAL statement (Provisionsabrechnung) of one agent for one run.
 * Read/list only: the generic create/update/delete is refused by the backend; statements are created via
 * the run endpoints and re-issued via `CpProvisionAgentStatementService.reissue$`.
 */
export class ProvisionAgentStatementDto extends DtoDetail {

    public provisionRunDto?: ProvisionRunDto;
    public provisionRunDtoId?: number;
    public provisionRunDtoName?: string;

    public provisionAgentDto?: ProvisionAgentDto;
    public provisionAgentDtoId?: number;
    public provisionAgentDtoName?: string;

    /** Statement number from the number range of the provision type. */
    public statementNumber: string;
    /** Version of the statement of this agent and run; a re-issue increments it. */
    public version: number;
    public status: ProvisionStatementStatus;

    /** The stored PDF in dm. */
    public dmDocumentDto?: DmDocumentDto;
    public dmDocumentDtoId: number;
    public dmDocumentDtoName?: string;

    /** Valuta window of the statement. */
    public windowFromValutaDate: Date;
    public windowToValutaDate: Date;

    public openingBalance: number;
    /** Movements of the window. */
    public periodMovementAmount: number;
    /** Bookings that landed in the window after the previous statement ("Nachträgliche Buchungen"). */
    public lateBookingAmount: number;
    /** All payouts in the window. */
    public payoutAmount: number;
    /** "Auszahlbar in diesem Lauf". */
    public runPayoutAmount: number;
    public closingBalance: number;
    public reserveClosingBalance: number;
    public openLiabilityAmount: number;

    public provisionTypeName?: string;
    public templateName?: string;
    /** Mandatory reason of the re-issue that replaced this statement. */
    public supersededReason?: string;

}
